module.exports = __webpack_public_path__ + "img/Troja-restaurant-4.bc2ed43d.jpg";